import React from "react";
import { BsFillFileEarmarkImageFill } from "react-icons/bs";

export default function EmptyListComponent({ text, size, height }) {
  return (
    <div className={`flex justify-center items-center mt-3 ${height}`}>
      <div className="">
        <div>{text}</div>
        <BsFillFileEarmarkImageFill
          size={size}
          className="ml-auto mr-auto mt-2"
        />
      </div>
    </div>
  );
}
